import Modal from "flowbite/lib/esm/components/modal"
import OverlayBase from "./overlay_base"

// Delegated modal controller — see overlay_base.js. Options are read from the
// modal element itself (data-modal-placement, data-modal-backdrop), as in
// Flowbite's own markup.
export default class extends OverlayBase {
  _create(element, id) {
    return new Modal(element, this._options(element), { id, override: true })
  }

  _options(element) {
    const { modalPlacement: placement, modalBackdrop: backdrop } =
      element.dataset
    return { ...(placement && { placement }), ...(backdrop && { backdrop }) }
  }
}
